import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICommit, IDataInput } from '../../../../interface/interfaces';

interface IInitialState {
    commitsLoading: boolean;
    commitsData: ICommit[];
    commitsError: string;
}

const initialState: IInitialState = {
    commitsLoading: false,
    commitsData: [],
    commitsError: '',
};

const commitsSlice = createSlice({
    name: 'commits',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchCommitsPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.commitsLoading = true;
            state.commitsData = [];
        },

        fetchCommitsFulfilled: (state: IInitialState, action: PayloadAction<ICommit[]>) => {
            state.commitsLoading = false;
            state.commitsData = action.payload;
            state.commitsError = '';
        },

        fetchCommitsFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.commitsLoading = false;
            state.commitsData = [];
            state.commitsError = action.payload;
        },
    },
});

export default commitsSlice.reducer;
export const { fetchCommitsPending, fetchCommitsFulfilled, fetchCommitsFailure } = commitsSlice.actions;
